import { Typography, useMediaQuery } from '@mui/material';
import { BooleanField, CreateButton, Datagrid, DateField, List, ReferenceField, SimpleList, TextField } from 'react-admin';

const BlogList = () => {
	const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
	return (
		<List resource="blog" hasCreate actions={<CreateButton resource="blog" />}>
			{isSmall ? (
				<SimpleList
					primaryText={(record) => (
						<Typography textAlign="right" fontWeight={'600'}>
							{record.title?.he || record.title}
						</Typography>
					)}
				/>
			) : (
				<Datagrid dir="rtl" rowClick="edit" resource="blog">
					<TextField source="order" label="סדר" />
					<TextField source="title.he" label="כותרת" />
					<ReferenceField source="expert" reference="instructor/all" label="מומחה/ית">
						<TextField source="name" />
					</ReferenceField>
					<BooleanField source="published" label="פורסם" />
					<DateField source="published_at" label="תאריך פרסום" />
					<DateField source="createdAt" label="נוצר" />
				</Datagrid>
			)}
		</List>
	);
};

export default BlogList;
